import { render, staticRenderFns } from "./MarketItem.vue?vue&type=template&id=1b1deb04&scoped=true&"
import script from "./MarketItem.vue?vue&type=script&lang=ts&"
export * from "./MarketItem.vue?vue&type=script&lang=ts&"
import style0 from "./MarketItem.vue?vue&type=style&index=0&id=1b1deb04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1deb04",
  null
  
)

export default component.exports